
// Curve step for the left (front) and the right (back) side
export const curves = {
    front: -2.7,
    back: 17,
};

export const controlElementInnerRadius = 8;
export const controlElementOuterRadius = controlElementInnerRadius * 1.75;
export const halfViewBoxHeight = controlElementOuterRadius;
export const viewBoxHeight = controlElementOuterRadius * 2;
export const firstDotIndent = 6;

export const indentFromFirstDotForLeftPointX = 2.5;
export const indentFromMiddleForLeftPointY = 2.28;
export const indentFromTopForRightPointY = 2.3;

export const additionalShiftForClick = .05;
